export const styles = {
  formControl: {
    maxWidth: 'max-content',
    minWidth: '200px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    '& .MuiInput-root': {
      fontSize: 14,
    },
  },
  fullWidth: {
    width: '100%',
    maxWidth: '100%',
  },
  select: {
    height: '30px',
    fontSize: '14px',
    color: '#8F8F8F',
    backgroundColor: 'transparent',
  },
  label: { fontSize: '14px', fontWeight: '400', marginRight: 10 },
  menuItemStyle: {
    fontSize: '12px !important',
    padding: '4px 10px !important',
    minWidth: '140px',
  },
  topicItemStyle: {
    textAlign: 'center !important',
    lineHeight: '34px !important',
    minWidth: '140px',
  },
  flexColumn: {
    flexDirection: 'column',
    alignItems: 'normal',
  },
}
